import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ReservationComponent } from "@web/app/components/dialogs/reservation/reservation.component";
import {
  AiAgentUiCommand,
  AiAgentUiCommandContext,
  AiAgentUiCommandHandler,
} from "../ai-agent-ui-command.types";

@Injectable({ providedIn: "root" })
export class OpenReservationHandler implements AiAgentUiCommandHandler {
  constructor(private dialog: MatDialog, private router: Router) {}

  supports(type: string): boolean {
    return type === "openReservation";
  }

  async handle(cmd: AiAgentUiCommand, _ctx?: AiAgentUiCommandContext): Promise<void> {
    if (!cmd.reservationId) {
      return;
    }
    if (cmd.navigateToCalendar) {
      const queryParams: Record<string, string> = {
        openReservationId: cmd.reservationId,
      };
      if (cmd.focusDate) {
        queryParams["date"] = cmd.focusDate;
      }
      await this.router.navigate(["/calendar"], { queryParams });
    }
    this.dialog.open(ReservationComponent, {
      width: "98vw",
      maxWidth: "1150px",
      data: { reservationId: cmd.reservationId },
    });
  }
}
